import React from 'react';
import { Link } from 'react-router-dom';

import { pausedRulesOf, pausedYourRulesWords } from '../../utils/pausedRules';

/**
 * The person's own running rules an install, an add-on or a bundle update
 * paused (KPR-1372): named as theirs, each a link to the Automations tab of
 * the collection the rule lives in (a sub-collection's own, not the
 * target's). Apart from the pack's own rules that arrive paused. Names are
 * user data and render as text. Nothing renders when none was paused.
 */
export default function PausedRulesNotice({ pausedRules, ownIds, onNavigate }) {
	const { total, shown, more } = pausedRulesOf(pausedRules, ownIds);
	if (!total) return null;
	const { heading, reason } = pausedYourRulesWords(total);
	return (
		<div className="paused-rules" data-testid="paused-rules">
			<p className="paused-rules__lead">{heading}</p>
			<ul className="paused-rules__list">
				{shown.map(row => (
					<li key={row.key}>
						{row.href ? <Link to={row.href} className="paused-rules__link" onClick={onNavigate}>{row.name}</Link> : <span className="paused-rules__name">{row.name}</span>}
					</li>
				))}
			</ul>
			{more ? <p className="meta-line">and {more} more.</p> : null}
			<p className="meta-line">{reason} Find {total === 1 ? 'it' : 'them'} in Waiting for you on the Automations tab.</p>
		</div>
	);
}
